import { addMarketplaceEntities, getMarketplaceEntities } from 'ducks/marketplaceData.duck';
import { storableError } from 'util/errors';
import { types } from 'util/sdkLoader';
import { filterOwnListings } from '../../own-listings/utils/api';

const { UUID } = types;

const FETCH_LISTINGS_REQUEST = 'app/fieldSelectListings/FETCH_LISTINGS_REQUEST';
const FETCH_LISTINGS_SUCCESS = 'app/fieldSelectListings/FETCH_LISTINGS_SUCCESS';
const FETCH_LISTINGS_ERROR = 'app/fieldSelectListings/FETCH_LISTINGS_ERROR';

const initialState = {
  listingRefs: [],
  fetchListingsInProgress: false,
  fetchListingsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_REQUEST:
      return { ...state, fetchListingsInProgress: true, fetchListingsError: null };
    case FETCH_LISTINGS_SUCCESS:
      return { ...state, fetchListingsInProgress: false, listingRefs: payload.listingRefs };
    case FETCH_LISTINGS_ERROR:
      return { ...state, fetchListingsInProgress: false, fetchListingsError: payload.error };
    default:
      return state;
  }
}

const fetchListingsRequest = () => ({ type: FETCH_LISTINGS_REQUEST });
const fetchListingsSuccess = (listingRefs) => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: { listingRefs },
});
const fetchListingsError = (error) => ({ type: FETCH_LISTINGS_ERROR, payload: { error } });

export const fetchListings = (params) => async (dispatch) => {
  dispatch(fetchListingsRequest());
  try {
    const listingsResponse = await filterOwnListings({ ...params, view: 'active' });
    const listingRefs = listingsResponse.data.data.map((listing) => ({
      id: listing.id,
      type: listing.type,
    }));
    dispatch(addMarketplaceEntities(listingsResponse));
    dispatch(fetchListingsSuccess(listingRefs));
  } catch (error) {
    dispatch(fetchListingsError(storableError(error)));
  }
};

export const selectFetchListingsInProgress = (state) =>
  state.fieldSelectListings.fetchListingsInProgress;
export const selectFetchListingsError = (state) => state.fieldSelectListings.fetchListingsError;
export const selectListings = (listingIds) => (state) => {
  if (!Array.isArray(listingIds) || listingIds.length === 0) {
    return [];
  }
  return (
    getMarketplaceEntities(
      state,
      listingIds.map((listingId) => ({
        id: new UUID(listingId),
        type: 'ownListing',
      }))
    ) || []
  );
};
export const selectFetchedListings = (state) => {
  const { listingRefs } = state.fieldSelectListings;
  return getMarketplaceEntities(state, listingRefs);
};
